export default class KdNodeVisitor {
  visit(node) {}
}
